export default {
    // market
    tabNews: 'ニュース',
    tabJobPostings: '求人情報',
    marketSort: "並び替え",
    marketFilter: "フィルター",
    marketReset: 'リセット',
    marketFilterGalleries: 'ギャラリー',
    marketFilterCategories: 'カテゴリー',
    recent: "最近",
    earlier: "以前",
    minuteAgo: "{count} 分前",
    hourAgo: "{count} 時間前",
    dayAgo: "{count} 日前",
    weekAgo: "{count} 週間前",
    on: 'に',
    readArticle: "記事を読む",
    viewPosting: "投稿を見る",
    moreNumber: "+{count} 件",


    // empty content text
    noNewsArticlesFound: "ニュース記事が見つかりません",
    nothingMatchSearch: "検索に一致するものがなかったようです。別のキーワードを試すか、後で最新の更新情報を確認してください！",
    noJobListingsAvailable: "利用可能な求人情報はありません",
    noJobPostingsMatching: "検索に一致する求人情報がないようです。別のキーワードを試すか、後で新しい機会を探しに戻ってきてください。",
    noAdsFound: "広告が見つかりません",
    noAdsFoundDesc: "現在、関連する広告は検出されていません。最新の出稿状況を後ほどご確認ください。",
    noActivitiesTrackedYet: 'まだアクティビティは追跡されていません',
    noAdsMatch: "検索条件に合う広告がありません",
    noAdsMatchDesc: "検索に一致する広告が見つかりません。キーワードを調整するか、最新の更新を後ほどご確認ください。",
    noTrackedAnyActivities: "この会社のアクティビティはまだ追跡されていません。後で更新情報を確認してください。",
    noTechnologiesFound: 'テクノロジーが見つかりません',
    cantFindAnyInformationOnTheTechnologies: "この会社が使用しているテクノロジーに関する情報が見つかりませんでした。更新情報にご期待ください。",
  

    // company info
    seeLess: "少なく見る",
    seeMore: "もっと見る",


    // technology
  
  };